import type { FC } from 'react';

import type { Props } from '@/components/StartConflictModal/types';
import { Modal } from '@/ui';
import { startConflictMessages } from '@/utils/startConflictMessage';

const StartConflictModal: FC<Props> = ({ conflicts, timeZone, onContinue, onCancel }) => {
  const messages = startConflictMessages(conflicts, timeZone);

  return (
    <Modal
      open={conflicts.length > 0}
      onClose={onCancel}
      title="Scheduling conflict"
      description={
        messages.length > 0 && (
          <div className="space-y-2">
            {messages.map((message, index) => (
              <p key={index}>{message}</p>
            ))}
          </div>
        )
      }
      primaryAction={{ label: 'Continue', onClick: onContinue }}
      secondaryAction={{ label: 'Cancel', onClick: onCancel }}
    />
  );
};

export default StartConflictModal;
